//Boostrap import
import Form from 'react-bootstrap/Form';

//React import
import { useContext, useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';

//Widgets import
import Modal from '../../atoms/modal/view';
import ButtonBasic from '../../atoms/buttonBasic/view';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import { useCarrito } from '../../../context/carrito/context';

import { getAllProducts } from '../../../usecases/products-usecase';
import './style.css';
import ThirdsModal from '../thirdsModal/view';

import { roleContext } from '../../../context/role/context';
import ButtonLoading from '../../atoms/buttonLoading/view';

import PaymentMethodSelector from '../../molecules/PaymentMethodSelector/view';
import { formatMoney } from '../../../utils/formating';
import ClientInfo from '../../atoms/ClientInfo/view';
import DateSelector from '../../atoms/datepicker/view';
import TaxSearchDropdown from '../../molecules/TaxSearchDropdown/view';

function BuyPayMethods({ tercero, onSubmit }) {

    const { profile, isElectronicInvoiceEnable } = useContext(roleContext);
    const { car, taxGroup, total, clearCart, xmlInvoiceData } = useCarrito();
    const [totalToPay, SetTotalToPay] = useState(0);
    const [retentionValue, SetRetentionValue] = useState(0);
    const [selectedFormPay, setSelectedFormPay] = useState(undefined);

    const [buyDate, setBuyDate] = useState(new Date());
    const [buyDocument, setBuyDocument] = useState("");
    const [cambio, SetCambio] = useState(0);
    const [isPayDisable, SetIsPayDisable] = useState(true);

    const [selectedMethods, setSelectedMethods] = useState([]);
    const [selectedRetention, setSelectedRetention] = useState(undefined);

    // Estado del documento soporte y del popup de decision
    const [isSupportDoc, setIsSupportDoc] = useState(false);
    const [showDecisionModal, setShowDecisionModal] = useState(false);

    useEffect(() => {
        const cleanCancel = listener("cancel-transaction", () => {
            setSelectedMethods([]);
            setSelectedFormPay(undefined);
            setBuyDocument("");
            setBuyDate(new Date());
            setSelectedRetention(undefined);
            SetRetentionValue(0);
            setIsSupportDoc(false);
            setShowDecisionModal(false);
        });
        return () => cleanCancel();
    }, []);

    useEffect(() => {
        if (!xmlInvoiceData) return;
        if (xmlInvoiceData.invoice_number && !buyDocument) {
            setBuyDocument(xmlInvoiceData.invoice_number);
        }
        if (xmlInvoiceData.payment_means_code && !selectedFormPay) {
            const code = xmlInvoiceData.payment_means_code;
            if (code === "1" || code === "10") {
                setSelectedFormPay("1");
            } else if (code === "2" || code === "ZZZ" || xmlInvoiceData.payment_due_date) {
                setSelectedFormPay("2");
            }
        } else if (xmlInvoiceData.payment_due_date && !selectedFormPay) {
            setSelectedFormPay("2");
        }
    }, [xmlInvoiceData, buyDocument, selectedFormPay]);

    async function handlePay() {
        const data = {
            tercero: tercero,
            expiration: window.document.getElementById("expiration-days")?.value || 0,
            documento_compra: buyDocument,
            buy_date: buyDate,
            methods: selectedMethods.map(method => ({
                ...method,
                payment_form_id: parseInt(selectedFormPay) || 1
            })),
            total: totalToPay,
            retention: selectedRetention,
            retention_value: retentionValue,
            items: car,
            taxes: taxGroup,
            xml_invoice_data: xmlInvoiceData
        };

        onSubmit(data, isSupportDoc).then(() => {
            const successMsg = isSupportDoc
                ? "Documento soporte y compra guardados con éxito"
                : "Compra guardada";
            dispatchCustomEvent("popup", { message: successMsg, type: "success" });
            dispatchCustomEvent("loading-btn", null);
            dispatchCustomEvent("modal-close", null);

            // Reset all states for next purchase
            setSelectedMethods([]);
            setSelectedFormPay(undefined);
            setBuyDocument("");
            setBuyDate(new Date());
            setSelectedRetention(undefined);
            SetRetentionValue(0);
            setIsSupportDoc(false);

            clearCart();
            getAllProducts(profile.uid, profile.cid);
        }).catch(() => {
            dispatchCustomEvent("loading-btn", null);
            const errMsg = isSupportDoc
                ? "Error emitiendo documento soporte"
                : "Error guardando compra";
            dispatchCustomEvent("popup", { message: errMsg, type: "error" });
        });
    }

    const handleSubTotal = useCallback((selected) => {
        const totalToPay = parseFloat(total);
        if (!selected.length) return [0, totalToPay];

        const sumPayMethods = selected.reduce((sum, method) => sum + method.value, 0);
        const remaining = totalToPay - sumPayMethods;

        return [
            remaining < -0.01 ? Math.abs(remaining) : 0, // Cambio
            remaining > 0.01 ? remaining : 0           // Pendiente
        ];
    }, [total]);

    useEffect(() => {
        SetTotalToPay(total);
        const handleSub = handleSubTotal(selectedMethods);
        SetCambio(handleSub[0] ? handleSub[0] : 0);

        const pending = handleSub[1];
        const payed = (pending - retentionValue) <= 0.01;
        const haveThird = !!tercero?.id || !!tercero?.name;

        SetIsPayDisable(!(payed && haveThird));
    }, [total, selectedMethods, retentionValue, tercero, handleSubTotal]);

    function handleFormOpen() {
        setSelectedRetention(undefined);
        SetRetentionValue(0);
    }

    useEffect(() => {
        if (selectedRetention && !isNaN(parseFloat(selectedRetention["value"]))) {
            const totalTaxes = taxGroup.reduce((sum, tax) => sum + (tax.subtotal || 0), 0);
            const totalBase = total - totalTaxes;
            const retention = parseFloat(selectedRetention["value"]);
            SetRetentionValue(Math.round(totalBase * retention));
        } else {
            SetRetentionValue(0);
        }
    }, [total, taxGroup, selectedRetention]);

    function handleRetention(retention_selected) {
        if (!retention_selected || isNaN(parseFloat(retention_selected["value"]))) {
            setSelectedRetention(undefined);
            SetRetentionValue(0);
            return;
        }
        setSelectedRetention(retention_selected);
    }

    function handlePayMethodChange(selected) {
        setSelectedMethods([...selected]);
    }

    // Al hacer click en Pagar/Metodos de pago
    function handleInitialPayClick(e) {
        if (e && e.stopPropagation) e.stopPropagation();
        if (isElectronicInvoiceEnable) {
            setShowDecisionModal(true);
        } else {
            setIsSupportDoc(false);
            handleFormOpen();
            dispatchCustomEvent('modalpaymethods', { eventKey: 'paymethods' });
        }
    }

    // Al responder el popup de decision
    function handleSelectSupportDocDecision(withSupportDoc) {
        setIsSupportDoc(withSupportDoc);
        setShowDecisionModal(false);
        handleFormOpen();
        dispatchCustomEvent('modalpaymethods', { eventKey: 'paymethods' });
    }

    if (!tercero?.name) {
        return (
            <ThirdsModal
                id="pay-buy-methods"
                type="provider"
                text="Proveedores"
                profile={profile}
            />
        );
    }

    return (
        <div>
            <ButtonBasic
                id="paymethods"
                title="Metodos de pago"
                onClick={handleInitialPayClick}
            />

            <Modal
                id="paymethods"
                width="fit-content"
                style={{ maxWidth: '95vw', maxHeight: '95vh' }}
            >
                <div className='pay-box-title'>
                    <h2>{formatMoney(totalToPay - retentionValue)}</h2>
                    {cambio > 0 && <p className="titles-cambio">Cambio {(formatMoney(cambio))}</p>}
                </div>

                <Form
                    id="paymethod-form"
                    action="javascript:void(0);"
                    className='pay-buy-methods-form'
                >
                    {/* Switch interactivo para cambiar de opinion hasta el ultimo momento */}
                    {isElectronicInvoiceEnable && (
                        <div className="support-doc-switch-banner mb-4">
                            <div className="support-doc-switch-info">
                                <span className="support-doc-switch-icon">{isSupportDoc ? '⚡' : '🧾'}</span>
                                <div>
                                    <div className="support-doc-switch-title">
                                        {isSupportDoc ? 'Documento Soporte Electrónico (DIAN)' : 'Solo Registro de Compra Interna'}
                                    </div>
                                    <div className="support-doc-switch-desc">
                                        {isSupportDoc
                                            ? 'Se transmitirá electrónicamente a la DIAN para este proveedor.'
                                            : 'Solo se registrará la compra en el sistema sin transmisión a la DIAN.'}
                                    </div>
                                </div>
                            </div>
                            <div className="support-doc-switch-control-box">
                                <Form.Check
                                    type="switch"
                                    id="buy-support-doc-switch"
                                    checked={isSupportDoc}
                                    onChange={(e) => setIsSupportDoc(e.target.checked)}
                                    label={isSupportDoc ? 'DIAN Activado' : 'Solo Compra'}
                                    className="support-doc-custom-switch"
                                />
                            </div>
                        </div>
                    )}

                    <div className="mb-4">
                        <div className="buy-methods-label">Información del Proveedor</div>
                        <ClientInfo tercero={tercero} notActions={true} type="provider" />
                    </div>

                    <div className="buy-methods-grid">
                        <div className="buy-methods-section">
                            <div className="buy-methods-input-group">
                                <Form.Group className="mb-0">
                                    <Form.Label className="buy-methods-label">Fecha de operación</Form.Label>
                                    <DateSelector
                                        label="Seleccionar fecha"
                                        date={buyDate}
                                        onChange={(date) => setBuyDate(date)}
                                    />
                                </Form.Group>
                                <br></br>
                                <Form.Group className="mb-3">
                                    <Form.Label className="buy-methods-label">Retención</Form.Label>
                                    <TaxSearchDropdown
                                        selected={selectedRetention}
                                        onSelected={(retention) => handleRetention(retention)}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-0">
                                    <Form.Label className="buy-methods-label">Documento de compra</Form.Label>
                                    <Form.Control
                                        id="document-buy"
                                        placeholder="Nro Factura / Documento"
                                        value={buyDocument}
                                        onChange={(e) => setBuyDocument(e.target.value)}
                                        className="form-control-premium"
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        <div className="buy-methods-section">
                            <div className="buy-methods-input-group" style={{ height: '100%' }}>
                                <div className="buy-methods-label mb-3">Métodos de Pago</div>
                                <PaymentMethodSelector
                                    selectedMethods={selectedMethods}
                                    onSelectMethod={handlePayMethodChange}
                                    onAmountChange={handlePayMethodChange}
                                    onRemoveMethod={handlePayMethodChange}
                                    enableFormPay={true}
                                    suggestedValue={handleSubTotal(selectedMethods)[1] - retentionValue}
                                    selectedFormPayValue={selectedFormPay}
                                    selectedFormPay={setSelectedFormPay}
                                    defaultAmount={totalToPay - retentionValue}
                                />
                            </div>
                        </div>
                    </div>
                </Form>

                <div className="mt-2">
                    <ButtonLoading
                        id="buy-pay-btn-loading"
                        title={tercero ? "Confirmar Compra" : "Agregue un proveedor"}
                        disabled={isPayDisable}
                        onClick={handlePay}
                    />
                </div>
            </Modal>

            {/* Popup modal para decidir al dar click en Pagar */}
            {showDecisionModal && createPortal(
                <div className="confirm-overlay modal" role="dialog" style={{ zIndex: 10000 }}>
                    <div className="support-doc-decision-card">
                        <div className="support-doc-decision-header">
                            <div className="support-doc-decision-icon-badge">
                                <span>📄</span>
                            </div>
                            <h3 className="support-doc-decision-title">Tipo de Comprobante</h3>
                            <p className="support-doc-decision-subtitle">
                                ¿Deseas emitir un <strong>Documento Soporte Electrónico (DIAN)</strong> para esta compra?
                            </p>
                        </div>

                        <div className="support-doc-decision-options">
                            <div
                                className="support-doc-option-btn option-dian"
                                onClick={() => handleSelectSupportDocDecision(true)}
                                role="button"
                                tabIndex={0}
                            >
                                <div className="option-btn-top">
                                    <span className="option-tag tag-dian">Recomendado DIAN</span>
                                    <span className="option-lightning">⚡</span>
                                </div>
                                <div className="option-name">Sí, Documento Soporte</div>
                                <div className="option-explanation">
                                    Transmite y valida ante la DIAN. Ideal para personas naturales no obligadas a facturar.
                                </div>
                            </div>

                            <div
                                className="support-doc-option-btn option-standard"
                                onClick={() => handleSelectSupportDocDecision(false)}
                                role="button"
                                tabIndex={0}
                            >
                                <div className="option-btn-top">
                                    <span className="option-tag tag-standard">Registro Interno</span>
                                    <span className="option-lightning">🧾</span>
                                </div>
                                <div className="option-name">No, Solo Registrar Compra</div>
                                <div className="option-explanation">
                                    Guarda en inventario y contabilidad sin transmisión electrónica a la DIAN.
                                </div>
                            </div>
                        </div>

                        <div className="support-doc-decision-footer">
                            <button
                                type="button"
                                className="btn-decision-cancel"
                                onClick={() => setShowDecisionModal(false)}
                            >
                                Cancelar y volver
                            </button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
}

export default BuyPayMethods;
